import {endpoint} from "./endpoint";

export const logout = endpoint({
  url: "/ui/logout",
  method: "get",
  params: undefined,
  payload: undefined,
  validate: undefined,
  shape: undefined,
});
